import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaSignOutAlt, FaStoreAlt } from "react-icons/fa";
import { Modal } from "antd";
import {
  admin_sidebar_route,
  vendor_sidebar_route,
} from "../../utils/routelist";
import { useSelector } from "react-redux";
import { success_toast_message } from "../../utils/toast_message";
import { exit_session } from "../../config/apiHandle";
import { IoSettings } from "react-icons/io5";

function SidebarCom({ isMobileMenuOpen, closeMobileMenu }) {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userAuth);
  const [isOpen, setIsOpen] = useState(true);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleConfirmLogout = () => {
    navigate("/login");
    success_toast_message("Logout Successfully");
    localStorage.removeItem("auth");
    closeMobileMenu();
    exit_session();
    setShowLogoutConfirm(false);
  };

  const _logouthandle = () => {
    setShowLogoutConfirm(true);
  };

  const roleManageRoute =
    user?.role === "Admin" ? admin_sidebar_route : vendor_sidebar_route;

  return (
    <div
      className={`bg-gray-900 text-white fixed md:relative inset-y-0 left-0 z-50 transform transition-all duration-300  
  ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 
  ${
    isOpen ? "md:w-64" : "md:w-20"
  } w-64 min-h-screen shadow-lg flex flex-col justify-between`}
    >
      {/* Logout Confirmation Modal */}
      <Modal
        title="Confirm Logout"
        visible={showLogoutConfirm}
        onOk={handleConfirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
        okText="Yes"
        cancelText="No"
      >
        <p>Are you sure you want to logout?</p>
      </Modal>

      {/* TOP SECTION */}
      <div className="p-4 flex justify-between items-center">
        <h1
          className={`text-2xl font-bold transition-all duration-300 ${
            isOpen ? "block" : isMobileMenuOpen ? "block" : "hidden"
          }`}
        >
          Dashboard
        </h1>
        <FaBars
          className="text-2xl cursor-pointer hidden md:block"
          onClick={toggleSidebar}
        />
      </div>

      {/* MIDDLE SECTION - Centered Nav */}
      <div className="flex-1 overflow-y-auto">
        <nav className="mt-2">
          {roleManageRoute.map((item, index) => {
            return (
              item.isShow && (
                <Link
                  key={index}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center gap-4 p-4 text-lg hover:bg-gray-700 rounded-md transition-colors duration-300 
                ${location.pathname === item.path ? "bg-gray-700" : ""}`}
                >
                  <span className="text-xl">{item.icon}</span>
                  <span
                    className={`${
                      isOpen ? "block" : isMobileMenuOpen ? "block" : "hidden"
                    } transition-all duration-300`}
                  >
                    {item.screenName}
                  </span>
                </Link>
              )
            );
          })}
        </nav>
      </div>

      {/* BOTTOM SECTION */}
      <div className="pb-4">
        {user?.role !== "Admin" && (
          <>
            <Link
              to={"/store"}
              className={`flex items-center gap-4 p-4 text-lg hover:bg-gray-700 rounded-md transition-colors duration-300 
            ${location.pathname === "/store" ? "bg-gray-700" : ""}`}
            >
              <span className="text-xl">
                <FaStoreAlt />
              </span>
              <span
                className={`${
                  isOpen ? "block" : isMobileMenuOpen ? "block" : "hidden"
                } transition-all duration-300`}
              >
                Store
              </span>
            </Link>

            <Link
              to={"/setting"}
              className={`flex items-center gap-4 p-4 text-lg hover:bg-gray-700 rounded-md transition-colors duration-300 
            ${location.pathname === "/setting" ? "bg-gray-700" : ""}`}
            >
              <span className="text-xl">
                <IoSettings />
              </span>
              <span
                className={`${
                  isOpen ? "block" : isMobileMenuOpen ? "block" : "hidden"
                } transition-all duration-300`}
              >
                Settings
              </span>
            </Link>
          </>
        )}

        <div
          onClick={_logouthandle}
          className="flex items-center cursor-pointer gap-4 p-4 text-lg hover:bg-red-600 rounded-md transition-colors duration-300"
        >
          <FaSignOutAlt className="text-xl" />
          <span
            className={`${
              isOpen ? "block" : isMobileMenuOpen ? "block" : "hidden"
            } transition-all duration-300`}
          >
            Logout
          </span>
        </div>
      </div>
    </div>
  );
}

export default SidebarCom;
